import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import mixinWhiteLabel from './mixins';
import globalTypes from '@/store/types/global';
// import authTypes from '@/store/types/auth';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'menuDigital',
      meta: {
        secure: false
      },
      component: () => import('./views/menuDigital.vue')
    },
    {
      path: '/error-404',
      name: 'error-404',
      meta: {
        secure: false
      },
      component: () => import('./views/Error404.vue')
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      meta: {
        secure: false
      },
      component: () => import('./views/Maintenance.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.hash === '') {
    store.commit(globalTypes.mutations.setLoadingGeneral, true);
  }
  let vendorUrl = mixinWhiteLabel.methods.subDomain();
  if (vendorUrl === 'qr' && (to.name === 'menuDigital' || to.name === 'menudigital')) {
    if (to.query.vendor !== undefined || to.query.source !== undefined) {
      if (to.query.vendor !== undefined) {
        vendorUrl = to.query.vendor;
      } else if (to.query.source !== undefined) {
        vendorUrl = to.query.source.split('.')[0];
        if (vendorUrl === 'www') {
          vendorUrl = to.query.source.split('.')[1];
        }
      }
      store.commit(globalTypes.mutations.setVendorUrl, vendorUrl);
      /* store.commit(authTypes.mutations.setUser);
      store.commit(authTypes.mutations.setUserId); */
      store.dispatch({ type: 'global:vendorId', data: { url: vendorUrl } }).then((response) => {
        if (response.data.code === 403) {
          store.commit(globalTypes.mutations.setLoadingGeneral, false);
          next({ path: '/maintenance' });
        }
        store.dispatch({
          type: 'whiteLabel:getIntegrationDefaults',
          data: {
            filter: 'front'
          }
        });
        store.dispatch({
          type: 'whiteLabel:getIntegrations',
          data: { vendorId: response.data.vendorId }
        });
        store.dispatch({ type: 'global:vendor', data: { vendorId: response.data.vendorId } }).then(({ data }) => {
          if (to.path === '/maintenance') {
            store.commit(globalTypes.mutations.setLoadingGeneral, false);
            data.data.vendor.isActive = 0;
            document.title = 'Mantenimiento';
          }
          if (!data.data.vendor.isActive && to.name !== 'maintenance') {
            store.commit(globalTypes.mutations.setLoadingGeneral, false);
            next({ path: '/maintenance' });
          }
          if (!to.matched.length) {
            store.commit(globalTypes.mutations.setLoadingGeneral, false);
            next({ path: '/error-404' });
          } else {
            store.commit(globalTypes.mutations.setLoadingGeneral, false);
            document.title = data.data.vendor.displayName;
            document.querySelector("link[rel*='icon']").href = data.data.vendor.thumbnailURL;
            next();
          }
        });
      })
        .catch(() => {
          store.commit(globalTypes.mutations.setLoadingGeneral, false);
          next({ path: '/maintenance' });
        });
    } else {
      store.commit(globalTypes.mutations.setLoadingGeneral, false);
      next({ path: '/maintenance' });
    }
  } else {
    if (!to.matched.length) {
      store.commit(globalTypes.mutations.setLoadingGeneral, false);
      next({ path: '/error-404' });
    } else {
      store.commit(globalTypes.mutations.setLoadingGeneral, false);
      next();
    }
  }
});

export default router;
